import { memo, useEffect, useState } from 'react';
// @mui
import { styled } from '@mui/material/styles';
import { Container, AppBar } from '@mui/material';
// config
import { HEADER } from '../../../config';
// components
import { NavSectionHorizontal } from '../../../components/nav-section';
//
import navConfig from './NavConfig';
import useAuth from 'src/hooks/useAuth';
import axios from 'src/utils/axios';
import { API_ENDPOINTS } from 'src/api_endpoints';

// ----------------------------------------------------------------------

const RootStyle = styled(AppBar)(({ theme }) => ({
  transition: theme.transitions.create('top', {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.shorter,
  }),
  width: '100%',
  position: 'fixed',
  zIndex: theme.zIndex.appBar,
  padding: theme.spacing(1, 0),
  boxShadow: theme.customShadows.z8,
  top: HEADER.DASHBOARD_DESKTOP_OFFSET_HEIGHT,
  backgroundColor: theme.palette.background.default,
}));

// ----------------------------------------------------------------------

function NavbarHorizontal() {
  const { getUserRole } = useAuth();

  const currentRole = getUserRole();
  const [hasAccountRights, setHasAccountRights] = useState(false);
  const [isLoadingAccountRights, setIsLoadingAccountRights] = useState(false);

  useEffect(() => {
    const checkAccountRights = async () => {
      try {
        setIsLoadingAccountRights(true);
        const response = await axios.get(API_ENDPOINTS.utility.hasappaccountingrights);
        setHasAccountRights(response.data);
      } catch (error) {
        console.error('Error checking account rights:', error);
        setHasAccountRights(false);
      } finally {
        setIsLoadingAccountRights(false);
      }
    };

    checkAccountRights();
  }, []);

  return (
    <RootStyle>
      <Container maxWidth={false}>
        <NavSectionHorizontal navConfig={navConfig(currentRole, hasAccountRights)} />
      </Container>
    </RootStyle>
  );
}

export default memo(NavbarHorizontal);
